<template>
  <div id="order_history_detail">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div
          class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60"
        >
          <div class="l-main__head">
            <router-link
              to="/mobileorder/history"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </router-link>
            <div class="l-main__head--title">注文・予約状況、履歴</div>
            <button class="l-main__head--btn-close" @click.prevent="$router.push('/mobileorder/history')">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </button>
          </div>
          <div class="l-check-cart">
            <div class="l-check-cart__head">
              <div class="c-history-detail c-history-detail--no-p mb-8">
                <div class="c-history-detail__content">
                  <div class="c-history-detail__content--time mb-8 d-flex">
                    <div>{{formatDateForOrder(order.aeonRegiPaymentRequestTime)}} <span>{{formatTimeForOrder(order.aeonRegiPaymentRequestTime)}}</span></div>
                    <div>{{deliveryMethod(order)}}</div>
                  </div>
                  <div class="c-history-detail__content--title mb-8">
                    <div class="icon">
                      <img :src="getImgSrc(order.provider && order.provider.image && order.provider.image[0])" alt="" />
                    </div>
                    <div class="title">{{order.provider.shopName}} <br />
                    <span class="phoneto" @click.prevent="phoneTo(order.provider.tel)">TEL: {{order.provider.tel}}</span></div>
                  </div>
                  <div class="c-history-detail__receipt">
                    <div class="receipt">
                      <span>{{order.orderType == '3' ? 'ご予約' : '受け取り'}}番号</span>
                      {{order.deliveryNumber | formatDeliveryNumber}}
                    </div>
                    <div class="shippingTime" v-if="order.status != 'COMPLETED'">
                      <span>{{order.orderType == '3' ? 'ご来店' : '受け取り'}}目安</span>
                      <div class="day" v-if="order.orderType == 3 || order.orderType == 1">
                        <div v-if="formatTimeForOrder(order.estimatedShippingTime,'day')">{{formatTimeForOrder(order.estimatedShippingTime,"day")}}</div>
                        <div>{{formatTimeForOrder(order.estimatedShippingTime)}}</div>
                      </div>
                      <template v-else>
                      {{formatTimeForOrder(order.estimatedShippingTime)}}
                      </template>
                    </div>
                    <div class="shippingTime" v-if="order.status == 'COMPLETED'">
                      <span>{{order.orderType == '3' ? 'ご来店' : '受け取り'}}日時</span>
                      {{order.completeTime && formatTimeForOrder(order.completeTime)}}
                    </div>
                    <div class="status">
                      <span>ステータス</span>
                      <div :class="{ CancelFailed: order.status == 'CANCEL_FAILED' }">
                        {{orderStatus(order)}}
                      </div>
                    </div>
                  </div>
                  <div class="c-history-detail__place" v-if="order.handlingFormat == '3' || order.handlingFormat == '4' || (order.handlingFormat == '2' && order.deliveryPlaceDetail && order.deliveryPlaceDetail.tableNo)">
                    <span>受け取り場所</span>
                    <template v-if="order.handlingFormat == '2'">店内でお食事　テーブル番号：{{order.deliveryPlaceDetail && order.deliveryPlaceDetail.tableNo}}</template>
                    <template v-if="order.handlingFormat == '3'">{{mobileOrderConfig.drivethruAreaName}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carNo}} ({{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carColor}})</template>
                    <template v-if="order.handlingFormat == '4'">{{mobileOrderConfig.parkAndPickupAreaName}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.parkingNo}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carNo}} ({{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carColor}})</template>
                  </div>
                  <div class="deliveryHelp detail" v-if="(shop && shop.deliveryContact) && (order.handlingFormat == '3' || order.handlingFormat == '4')"><a href="#" @click.prevent="openDeliveryHelp">お受け取りでお困りの場合はこちら</a></div>
                  <div class="c-order-info__body detail" v-if="(order.orderType == 1 && order.status == 'PREPARED') || order.status == 'DELIVERING'">
                    <div class="c-btn c-btn--red mt-16 box-center" @click.prevent="changeStatusCompleted(order.id, order.tenantId)">
                      受け取りました
                    </div>
                  </div>
                  <template v-if="order.orderType == 3 && order.status == 'PREPARING'">
                  <div class="c-order-info__body detail">
                    <div class="c-btn c-btn--red mt-16 box-center is-reservation" @click.prevent="changeStatusCompleted(order.id, order.tenantId)">
                      入店しました
                    </div>
                  </div>
                  <small>ご来店後、スタッフが確認したら押してください。</small>
                  </template>
                </div>
              </div>
              <hr />
              <div>
                <div class="l-check-cart__title-sub">{{order.orderType == '3' ? 'ご予約内容' : 'ご注文商品'}}</div>
                <div class="c-cart-box c-cart-box--payment mb-16" v-for="(product, productIndex) in order.orderProducts" :key="productIndex">
                  <div class="c-cart-box__head">
                    <div class="c-cart-box__img product-image">
                      <img :src="getImgSrc(product.image)" alt="" />
                    </div>
                  </div>
                  <div class="c-cart-box__body">
                    <ul>
                      <li>
                        <div class="c-cart-box__name">点数</div>
                        <div class="c-cart-box__price">{{product.quantity}}点</div>
                      </li>
                      <li>
                        <div class="c-cart-box__name">{{product.productName}}</div>
                        <div class="c-cart-box__price" v-if="product.price > 0">
                          {{priceFormat(getCartProductPriceTaxed(product, order.handlingFormat == '2' ? 'pickup' : '', baseHandlingFormat))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-if="product.discountAmount > 0">
                        <div class="c-cart-box__name">クーポン券適用</div>
                        <div class="c-cart-box__price">
                          <small class="discount">（-{{priceFormat(product.discountAmount)}}円）</small>
                        </div>
                      </li>
                      <li v-for="(option, optionIndex) in product.options" :key="optionIndex">
                        <div class="c-cart-box__name">{{option.optionName}}</div>
                        <div class="c-cart-box__price" v-if="product.price > 0">
                          {{priceFormat(getCartOptionPriceTaxed(product, option, order.handlingFormat == '2' ? 'pickup' : '', baseHandlingFormat))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-if="getTenantTimebaseReservation() && order.reservationNumberOfPeople > 0">
                        {{order.reservationNumberOfPeople}} 人
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="l-check-cart__title-sub mb-8">クーポンコード</div>
                <div class="l-check-cart__voucher-used mb-16">
                  {{order.couponCode || 'なし'}}
                </div>
              </div>
            </div>
            <div :class="{'l-check-cart__body': true, 'has-cart': hasCartItem}">
              <div class="c-calc-price mb-8">
                <ul>
                  <li>
                    <div>合計点数</div>
                    <div>{{getProductCount(order)}}点</div>
                  </li>
                  <li v-if="order.priceAmount1 > 0">
                    <div><small>小計</small><small>（税率8% 税別）</small></div>
                    <div><small>{{priceFormat(order.priceAmount1)}}円</small></div>
                  </li>
                  <li v-if="order.priceAmount2 - order.comissionFee > 0">
                    <div><small>小計</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(order.priceAmount2 - order.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="order.comissionFee > 0">
                    <div><small>手数料</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(order.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="order.taxAmount1 > 0">
                    <div><small>税額(8%)</small></div>
                    <div><small>{{priceFormat(order.taxAmount1)}}</small>円</div>
                  </li>
                  <li v-if="order.taxAmount2 > 0">
                    <div><small>税額(10%)</small></div>
                    <div><small>{{priceFormat(order.taxAmount2)}}円</small></div>
                  </li>
                  <li v-if="order.discountAmount > 0">
                    <div><small>クーポン券適用</small></div>
                    <div><small class="discount">-{{priceFormat(order.discountAmount)}}円</small></div>
                  </li>
                  <hr />
                  <li v-if="order.totalAmount > 0">
                    <div>合計<small>（税込）</small></div>
                    <div>{{priceFormat(order.totalAmount)}}円</div>
                  </li>
                </ul>
                <div class="mb-8" v-if="order.totalAmount > 0">
                  ※消費税は小計に記載の本体価格に対し計算の上、合計(税込)額を表示しています<br />
                  ※消費税の計算により店頭価格と端数が異なる場合がございます
                </div>
              </div>
              <div class="c-box-method mb-8">
                <div class="c-box-method__title mb-16">ご利用方法</div>
                <ul class="no-border">
                  <li v-if="order.handlingFormat == 1">
                    <label for="radio-1" class="c-box-method__name">
                      お持ち帰り
                    </label>
                  </li>
                  <li v-if="order.handlingFormat == 2">
                    <label for="radio-1" class="c-box-method__name">
                      店内でお食事
                    </label>
                  </li>
                  <li v-if="order.handlingFormat == 3">
                    <label for="radio-1" class="c-box-method__name">
                      ドライブスルー
                    </label>
                  </li>
                  <li v-if="order.handlingFormat == 4">
                    <label for="radio-1" class="c-box-method__name">
                      専用駐車場で受け取り
                    </label>
                  </li>
                  <li v-if="order.handlingFormat == 5">
                    <label for="radio-1" class="c-box-method__name">
                      ご来店予約
                    </label>
                  </li>
                </ul>
              </div>
              <div class="c-box-method mb-8" v-if="order.receiveDate">
                <div class="c-box-method__title mb-16">{{order.orderType == '3' ? 'ご予約日' : 'お受け取り日'}}</div>
                <ul class="no-border">
                  <li>
                    <label for="radio-1" class="c-box-method__name">
                      {{formatDateForOrder(order.receiveDate)}}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="c-box-method" v-if="order.totalAmount > 0">
                <div class="c-box-method__title mb-10 mt-10">
                  <img
                    src="/assets/images/icon/icon-card.svg"
                    alt=""
                  />お支払いクレジットカード
                </div>
                <div class="c-selected mb-8" v-if="order.creditCardType == 2">イオンカード</div>
                <div class="c-selected mb-8" v-if="order.creditCardType == 1">イオンカード以外（VISA、MASTERのみ）</div>
              </div>
              <div v-if="!isTenantClosing()" class="c-btn c-btn--red box-center mt-24 mb-24" @click.prevent="addCartAgain">
                {{order.orderType == '3' ? '再度予約する' : '再度カートに追加する'}}
              </div>
              <div v-if="order.totalAmount > 0 && showReceipt(order)" class="c-btn c-btn--red box-center mt-24 mb-24" @click.prevent="makeReceipt(order)">
                領収書を表示する
              </div>
              <div class="l-order__link mt-16 mb-16" v-if="order.status == 'ORDER_SUCCEED'">
                <a class="l-order__link" href="javascript:void(0)" @click.prevent="cancelOrder"
                  >{{order.orderType == '3' ? '予約' : '注文'}}をキャンセルする</a
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-cart></footer-cart>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
      <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        :confirm_title="confirm_title"
        :confirm_centering="confirm_centering"
      ></alert>
      <confirm-continue :show="showContinueDialog" :orderType="postItem" />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common, eventBus } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { DB, firebaseProject } from "../config/const";
import firebase from "../common/firebaseProject";
import { getShop, getProvider, getProduct, getProductOptions, generateDocumentId, getOrderFromGroup, getMobileOrderConfig } from "../store/firestore";
import store from "../store";
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import ConfirmContinue from "../components/ConfirmContinue.vue";

export default Vue.extend({
  name: "MobileOrderHistoryDetail",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    'alert': Alert,
    PopAlert,
    ConfirmContinue
  },
  mixins: [Tenant],
  store,
  mounted() {
    Common.initDom();
  },
  async created() {
    this.loading = false;
    const shopId = this.$store.state.shopId;
    this.shop = await getShop(shopId);
    const userId = this.$store.state.userId;
    const orderId = this.$route.params.id;
    this.order = await getOrderFromGroup(orderId, userId);

    if (!this.order) {
      await this.confirm("指定された注文状況・履歴がみつかりませんでした。モバイルオーダートップに戻ります。", true);
      this.$router.push('/mobileorder');
    }
    this.tenant = await getProvider(this.order.tenantId, true);
    let handlingFormatSetting = null;
    switch(this.order.handlingFormat) {
      case 1: handlingFormatSetting = this.tenant?.handlingFormatToGo; break;
      case 2: handlingFormatSetting = this.tenant?.handlingFormatForHere; break;
      case 3: handlingFormatSetting = this.tenant?.handlingFormatDeliveryLane; break;
      case 4: handlingFormatSetting = this.tenant?.handlingFormatDeliveryParking; break;
    }
    this.baseHandlingFormat = handlingFormatSetting;
    const handlingFormats = this.getHandlingFormats(this.tenant, this.order.orderType == 1 ? 'pickup' : 'delivery');
    this.handlingFormats = handlingFormats;
    switch (this.order.orderType) {
      case 1:
        this.setting = this.tenant.pickUp;
        break;
      case 3:
        this.setting = this.tenant.reservation;
        break;
      default:
        this.setting = this.tenant.delivery;
        break;          
    }

    this.mobileOrderConfig = await getMobileOrderConfig();
    var _this = this;
    eventBus.$on('orderUpdated', async function(orderData, status, changedAt) {
      if(orderData.id == orderId){
        _this.order = await getOrderFromGroup(orderId, userId);
      }
    });
  },
  data() {
    return {
      shop: undefined,
      order: undefined,
      product: undefined,
      tenant: undefined,
      setting: undefined,
      loading: true,
      showContinueDialog: false,
      handlingFormats: [],
      hasCartItem: Object.values(this.$store.state.cart)?.length > 0,
      mobileOrderConfig: null,
      baseHandlingFormat: null,
      postItem: null,
      CartProcessing:false
    }
  },
  methods: {
    orderStatus(order){
      if (order.orderType != 3) {
        switch(order.status){
          case "ORDER_SUCCEED":
            return "注文完了";
          case "ORDER_FAILED":
            return "注文エラー";
          case "PREPARING":
            return "商品準備中";
          case "PREPARED":
            if (order.handlingFormat == '1' || order.handlingFormat == '2') {
              return "お受け取り待ち";
            } else if (order.handlingFormat == '3' || order.handlingFormat == '4') {
              return "お届け準備中";
            }
            break;
          case "DELIVERING":
            return "お届け中";
          case "COMPLETED":
            return "受け取り完了";
          case "CANCEL_REQUESTED":
            return "キャンセル受付";
          case "CANCEL_SUCCEED":
            return "キャンセル済";
          case "CANCEL_FAILED":
            return "キャンセルエラー";
        }
      } else {
        switch(order.status) {
          case "ORDER_SUCCEED":
            return "ご予約完了";
          case "ORDER_FAILED":
            return "ご予約エラー";
          case "PREPARING":
            return "ご予約確定";
          case "PREPARED":
            return "ご来店待ち";
          case "COMPLETED":
            return "ご来店済み";
          case "CANCEL_REQUESTED":
            return "キャンセル受付";
          case "CANCEL_SUCCEED":
            return "キャンセル済";
          case "CANCEL_FAILED":
            return "キャンセルエラー";
        }
      }
    },
    getTenantTimebasePickup() {
      if (this.tenant) {
        return this.tenant.enableTimebasePickup;
      }
      return false;
    },
    getTenantTimebaseReservation() {
      if (this.tenant) {
        return this.tenant.enableTimebaseReservation;
      }
      return false;
    },
    deliveryMethod(order) {
      if (order.orderType == 1) {
        return "モバイルオーダー";
      } else if (order.handlingFormat == 3) {
        return "ドライブスルー";
      } else if (order.handlingFormat == 4) {
        return "駐車場受け取り";
      } else if (order.orderType == 3) {
        return "ご来店予約";
      }
    },
    getProductCount(tenantCart) {
      return tenantCart.orderProducts.reduce((total, item) => {
        return total + item.quantity
      }, 0);
    },
    isInService() {
      let orderTypeEnabled;
      let orderTypeDiscloseAt;
      switch(this.order.orderType){
        case 1:
          orderTypeEnabled = this.tenant?.pickupEnabled;
          orderTypeDiscloseAt = this.tenant?.pickupDiscloseAt;
          break;
        case 2:
          orderTypeEnabled = this.tenant?.deliveryEnabled;
          orderTypeDiscloseAt = this.tenant?.deliveryDiscloseAt;
          break;
        case 3:
          orderTypeEnabled = this.tenant?.reservationEnabled;
          orderTypeDiscloseAt = this.tenant?.reservationDiscloseAt;
          break;
      }
      if (
        !orderTypeEnabled ||
        (orderTypeDiscloseAt && orderTypeDiscloseAt > Date.now())
      ) {
        return false;
      }

      if (this.order.orderType == 1 && this.tenant.enableTimebasePickup) {
        return true;
      }
      if (this.order.orderType == 3 && this.tenant.enableTimebaseReservation) {
        return true;
      }

      const now = Date.now();
      const available = this.getAvailableRanges(this.setting);
      const matched = available.filter(range => {
        const start = dayjs().startOf("date").add(range.min, "hour");
        const end = dayjs().startOf("date").add(range.max + 1, "hour");
        return start <= now && end > now;
      })
      return matched.length > 0;
    },
    generateOrderId() {
      return generateDocumentId();
    },
    async cancelOrder() {
      const result = await this.confirm("ご注文をキャンセルします。よろしいですか？");
      if (result) {
        this.loadingShow();
        const idToken = await this.getIdToken();
        if (!idToken) return;
        const callable = firebase.functions('asia-northeast1').httpsCallable('cancel');
        const data = {
          tenantId: this.order.tenantId,
          orderId: this.order.id,
          iid: this.$store.state.installId
        }
        const result = await callable(data)
        .catch(async e => {
          this.loadingHide();
          await this.confirm("キャンセルを承れませんでした。キャンセルをご希望の場合は、ご注文店舗にお問い合わせください。", true);
          this.$router.go();
        })
        .then(() => {
          this.loadingHide();
          this.$router.go();
        })
      }
    },
    phoneTo(phoneNumber){
      Common.messageHandlers('show_browser', { url: `tel:${phoneNumber.split('-').join('')}` });
    },
    async changeStatusCompleted(orderId, tenantId) {
      const idToken = await this.getIdToken();
      if (!idToken) return;
      const callable = firebase.functions('asia-northeast1').httpsCallable('changeOrderStatus');
      const params = {
        tenantId: tenantId,
        orderId: orderId,
        status: "COMPLETED",
        iid: this.$store.state.installId
      };
      this.loadingShow();
      await callable(params)
      .then(() => {
        //OK
        this.loadingHide();
        this.$router.go();
      })
      .catch(err => {
        this.loadingHide();
        this.alert("ご注文ステータスが更新できませんでした。しばらくしてからご確認ください。");
      })
    },
    async addCartAgain() {

      if (this.CartProcessing) return false;
      this.CartProcessing = true;
      const now = Date.now();

      if(!this.isInService()){
        await this.alert("現在注文を受け付けられません。");
        this.CartProcessing = false;
        return;
      }

      const cart = this.$store.state.cart || {};

      //現在のカートの購入方式を確認
      const cartItems = Object.values(cart);
      if (cartItems.length > 0){
        const handlingFormatOfOrder = this.order.handlingFormat;
        const handlingFormatOfCart = cartItems[0].handlingFormat;
        if (([1,2].includes(handlingFormatOfOrder) && [1,2].includes(handlingFormatOfCart)) || handlingFormatOfOrder == handlingFormatOfCart) {
          //OK
        } else {
          //NG
          this.alert("現在カートに入っている提供方式と異なる方式でのご注文のため、合わせてご注文いただけません。\n現在のカートで決済後にご注文いただくか、カートを空にしてからご注文ください。");
          this.CartProcessing = false;
          return;
        }
      }

      const type = this.getOrderTypeString(this.order.orderType);
      const orderKey = `${this.order.tenantId}_${type}`;
      const cartId = this.$store.state.cartId || this.generateOrderId();
      const orderType = this.order.orderType;

      if (!cart[orderKey]) {
        const orderId = this.generateOrderId();
        cart[orderKey] = {
          orderType: orderType,
          userId: this.$store.state.userId,
          tenantId: this.tenant.id,
          orderGroupId: cartId,
          orderId: orderId,
          receiveDate: null,
          totalAmount: 0,
          priceAmount: 0,
          discountAmount: 0,
          taxAmount: 0,
          comissionFee: 0,
          comissionTaxRate: 10,
          orderProducts: [],
          deliveryPlace: "",
          deliveryPlaceDetail: {}
        }
      }
      
      //日時指定予約用
      // 人数（全商品分の合算）
      cart[orderKey].reservationNumberOfPeople = (this.order.reservationNumberOfPeople) ? this.order.reservationNumberOfPeople : 0;
      //時間指定予約かどうか
      cart[orderKey].isTimeReservation = (this.order.isTimeReservation) ? this.order.isTimeReservation : false;

      let addedItems = 0;

      for(var i=0; i<this.order.orderProducts.length; i++){
        const productId = this.order.orderProducts[i].productId;
        const productName = this.order.orderProducts[i].productName;
        const product = await getProduct(this.tenant.id, productId, this.$store.state.userId);

        if (!product) {
          await confirm(`${productName}は現在ご注文いただけません。`, true);
          continue;
        } else if (product.soldout) {
          await confirm(`${productName}は現在売り切れのためご注文いただけません。`, true);
          continue;
        }
        const oldPrice = this.order.orderProducts[i].price;
        let newPrice = 0;
        if(this.order.orderProducts[i].taxCalculation == 2) {
          //内税
          newPrice = this.getProductSalePriceInTax(product, this.order.orderProducts[i].taxRateType)
        } else {
          //外税
          newPrice = this.getProductPrice(product, this.order.orderProducts[i].taxRateType, "sale");
        }
        if(oldPrice != newPrice) {
          const result = await this.confirm(`${productName}の価格が変更されています。(${oldPrice}円⇒${newPrice}円)　こちらの商品をカートに追加しますか？`);
          if (!result) {
            continue;
          }
        }

        const productOptions = await getProductOptions(this.tenant.id, product);
        let optionsSelected = [];
        for(var ii=0; ii<productOptions.length; ii++){
          const option = productOptions[ii];
          const optionGroupOptionId = option.optionGroupOptionId;
          const selected = this.order.orderProducts[i].options.filter(option => option.optionGroupOptionId == optionGroupOptionId);
          if (option.required && selected.length == 0) {
            await this.confirm(`${productName}で必須のオプションの一部が選択されていません。商品ページよりあらためてカートに入れてください。`, true);
            continue;
          }
          optionsSelected = optionsSelected.concat(selected);
        }
        const optionsNotAvailable = this.order.orderProducts[i].options.filter(option => productOptions.map(o => o.optionGroupOptionId).indexOf(option.optionGroupOptionId) == -1);
        if (optionsNotAvailable.length > 0){
          const result = await this.confirm(`${productName}でオプションの一部に現在利用できないものがあります。利用できないもの以外のオプションを設定してカートに追加しますか？`);
          if (!result){
            continue;
          }
        }

        const getAvailableHandlingFormats = this.getAvailableHandlingFormats(cart[orderKey], this.tenant);
        const handlingFormats = this.handlingFormats;
        
        if (type == 'pickup'){
          const productHandlingFormats = (orderType == 1 ? product.acceptableHandlingFormatForPickup : product.acceptableHandlingFormatForDelivery)
          ?.filter(f => handlingFormats.includes(f)) || [];
          const intersects = getAvailableHandlingFormats.filter(f => productHandlingFormats?.indexOf(f) != -1);
          if (intersects.length == 0){
            //Not able to add to cart
            const handlingFormatName = this.getHandlingFormatName(productHandlingFormats[0]);
            await this.confirm(`${productName}は${handlingFormatName}のみのご提供となりますが、カート内にこの方式に対応できない商品が含まれているため、カートに追加できません。`, true);
            continue;
          } else if (getAvailableHandlingFormats.length < productHandlingFormats.length){
            //Less availability of cart
            const handlingFormatName = this.getHandlingFormatName(intersects[0]);
            const result = await this.confirm(`すでに${handlingFormatName}のみの商品がカートに入っているため、${productName}についても${handlingFormatName}となりますがよろしいですか？`);
            if (!result) {
              continue;
            }
          } else if (productHandlingFormats.length < getAvailableHandlingFormats.length) {
            //Less availability of product
            const handlingFormatName = this.getHandlingFormatName(intersects[0]);
            const result = await this.confirm(`${productName}は${handlingFormatName}のみのご提供となるため、${productName}をカートに入れますとすべて${handlingFormatName}となりますがよろしいですか？`);
            if (!result) {
              continue;
            }
          }
          cart[orderKey].handlingFormat = intersects[0];
          cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, intersects[0]);
        } else {
          cart[orderKey].handlingFormat = this.order.handlingFormat;
          cart[orderKey].handlingFormatSetting = this.getHandlingFormatSetting(this.tenant, this.order.handlingFormat);
        } 

        //同じ製品かどうか判定
        const sameProduct = cart[orderKey].orderProducts.find(item => {
          return item.productId == productId && optionsSelected.filter(opt => {
            const sameOpt = item.options.find(o => o.optionId == opt.optionId && o.optionGroupOptionId == opt.optionGroupOptionId);
            return sameOpt != null
          }).length == optionsSelected.length 
          && optionsSelected.length == item.options.length
        })

        //同じ製品の場合数量追加のみ
        if (sameProduct) {
          sameProduct.quantity += parseInt(this.order.orderProducts[i].quantity);
          sameProduct.tmpQuantity += parseInt(this.order.orderProducts[i].quantity);
        } else {
          //違う場合は新しく追加する
          let price = 0;
          let inTax = {}
          //税抜き金額を挿入
          if (this.order.orderProducts[i].taxCalculation == 2) {
            price = this.getProductSalePriceInTax(product, this.order.orderProducts[i].taxRateType);
            //内税用の値
            inTax = {
              priceIncluded1:product.priceIncluded1,
              priceIncluded2:product.priceIncluded2,
              taxAmount1:product.taxAmount1,
              taxAmount2:product.taxAmount2,
              taxRateType:this.order.orderProducts[i].taxRateType,
              taxAmount: this.getProductInTax(product, this.order.orderProducts[i].taxRateType)
            }
          } else {
            price = this.getProductPrice(product, this.order.orderProducts[i].taxRateType,"sale");
          }
        
          cart[orderKey].orderProducts.push({
            productId: productId,
            productName: product.productName,
            image: product.image && product.image[0],
            quantity: this.order.orderProducts[i].quantity,
            tmpQuantity: this.order.orderProducts[i].quantity,
            price: price,
            taxRate1: parseInt(product.taxRate1),
            taxRate2: parseInt(product.taxRate2),
            acceptableHandlingFormatForPickup: product.acceptableHandlingFormatForPickup,
            acceptableHandlingFormatForDelivery: product.acceptableHandlingFormatForDelivery,
            options: optionsSelected,
            requiredTime:(product.requiredTime) ? product.requiredTime : 0,
            taxCalculation:parseInt(product.taxCalculation),
            ...inTax
          })
        }
        addedItems++;
      }

      if(addedItems > 0){
        this.$store.dispatch('updateCart', { cartData: cart, })
        .then(() => {
          let type = null;
          switch(this.order.handlingFormat){
            case 1:
            case 2: 
              type = 'pickup';
              break;
            case 3:
              type = 'drivethru';
              break;
            case 4: 
              type = 'parkandpickup';
              break;
            case 5:
              type = 'reservation';
              break;
            default:
            break;
          }
          this.postItem = {
            type:type,
            tenant:this.tenant.id
          };
          this.CartProcessing = false;
          this.showContinueDialog = true;
        })
        .catch(err => {
          this.CartProcessing = false;
          if(err?.userMessage){
            this.alert(err.userMessage);
          } else {
            this.alert("エラーが発生しました。");
          }
        });
      } else {
        this.CartProcessing = false;
      }
    },
    showReceipt(order){
      switch(order.status){
        case "COMPLETED":
          return true;
        case "ORDER_SUCCEED":
        case "PREPARING":
        case "PREPARED":
        case "DELIVERING":
        case "CANCEL_SUCCEED":
        case "ORDER_FAILED":
        case "CANCEL_REQUESTED":
          return false;
        default:
          return false;
      }
    },
    async makeReceipt(order) {

      var docRef = DB.collection('shop').doc(this.tenant.shopId);
      var shop = await docRef.get();
      var _shop = shop.data();
      //if (this.user?.gender == 1) {

      //console.log(_shop.name);

      var json = {
        id: order.id,
        aeonRegiPaymentRequestTime: this.formatDateForOrder(order.aeonRegiPaymentRequestTime),
        scName:_shop.name,
        shopName: order.provider.shopName,
        salesDistributor: this.tenant.salesDistributor,
        distributorLocation: this.tenant.distributorLocation,
        distributorContact: this.tenant.distributorContact,
        creditCardType: order.creditCardType,
        deliveryNumber: order.deliveryNumber,
        priceAmount1: order.priceAmount1,
        priceAmount2: order.priceAmount2,
        comissionFee:order.comissionFee,
        taxAmount1:order.taxAmount1,
        taxAmount2:order.taxAmount2,
        discountAmount: order.discountAmount,
        totalAmount: order.totalAmount,
        orderProducts: order.orderProducts,
        handlingFormat:order.handlingFormat,
        baseHandlingFormat:this.baseHandlingFormat,
        companyTaxId: order.provider.companyTaxId
      };

      //税率について
      //小計は商品設定及び提供方法によって8％か10％
      //手数料は10％固定
      //税額は上記のものがあれば両方

      const txt = JSON.stringify(json);
      const utf8Bytes = new TextEncoder().encode(txt);
      const basetxt = encodeURIComponent(window.btoa(String.fromCharCode(...utf8Bytes)));
      const HOSTNAME = window.location.hostname;
      const SET_URL = `https://${HOSTNAME}`; 
      const makeURL = `${SET_URL}/receipt/index.html?params=${basetxt}&ver=20230919`;
      Common.messageHandlers('show_browser', { url: makeURL });

    },
    isTenantClosing(){
      if (this.tenant.closeAt < Date.now()) {
        return true;
      }
      return false;
    }
  }
});
</script>